<template>
  <va-modal
    v-model="state.isOpen"
    hide-default-actions
    :title="$t('organizations.createModal.title')"
  >
    <slot>
      <div class="create-organization-modal">
        <va-input
          v-model="state.organizationName"
          label="Organization Name"
          placeholder="Enter organization name"
        />
      </div>
    </slot>

    <template #footer>
      <va-button flat outline class="mr-1" @click="emit('cancel')">
        {{ $t("buttons.cancel") }}
      </va-button>
      <va-button class="ml-1" color="primary" @click="createOrganization">
        {{ $t("buttons.submit") }}
      </va-button>
    </template>
  </va-modal>
</template>

<script setup>
import { computed, reactive } from "vue";

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false
  }
});

const state = reactive({
  isOpen: computed(() => props.isOpen),
  organizationName: ""
});

const emit = defineEmits(["cancel", "create"]);

const createOrganization = () => {
  if (state.organizationName.trim()) {
    const payload = state.organizationName;

    emit("create", payload);
    state.organizationName = "";
  }
};
</script>

<style scoped>
.create-organization-modal {
  min-width: 400px;
}

.va-input {
  margin-bottom: 1rem;
}

.switch-container {
  display: flex;
  align-items: center;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.ml-2 {
  margin-left: 0.5rem;
}
.checkbox {
  margin-right: 0.5rem;
  align-items: center;
  background-color: var(--va-checkbox-square-background-color);
  border: var(--va-checkbox-square-border);
  border-radius: var(--va-checkbox-square-border-radius);
  display: flex;
  height: var(--va-checkbox-square-height);
  justify-content: center;
  min-width: var(--va-checkbox-square-min-width);
  position: var(--va-checkbox-square-position);
  width: var(--va-checkbox-square-width);
}
</style>
